import { 
	SHOW_ALERT, 
	HIDE_ALERT, 
	SET_MESSAGE, 
	SET_LOCATION, 
	SET_LIGHT_FOOTER,
	SET_POPUP,
	HIDE_POPUP,
	SET_SUBSCRIPTION_POP_UP,
	SET_LOAD_SPINNER,
} from '../types';

export const setMessage = (alert) => {
	return {
		type: SET_MESSAGE,
		payload: alert
	};
};

export const showAlert = (alert) => {
	return {
		type: SHOW_ALERT,
		payload: alert
	};
};

export const hideAlert = () => {
	return {
		type: HIDE_ALERT
	};
};
export const setLocation = (location) => {
	return {
		type: SET_LOCATION,
		payload: location
	};
};

export const setLightFooter = (result) => {
	return {
		type: SET_LIGHT_FOOTER,
		payload: result
	};
};
export const setPopup = (data) => {
	return {
		type: SET_POPUP,
		payload: data
	};
};
export const hidePopup = () => {
	return {
		type: HIDE_POPUP
	};
};

export const setSubscriptionPopUp = (isActive) => {
	return {
		type: SET_SUBSCRIPTION_POP_UP,
		payload: isActive
	}
};

export const setLoadSpinner = (isLoad) => {
	return {
		type: SET_LOAD_SPINNER,
		payload: isLoad
	}
};
